<template>
  <div style="" class="father">
    <wty-permission
      v-if="wtypermiss_show"
      :who="'peopleinfo'"
      :perssionData="perssionData"
      :tableList="tableList"
      :tableClumn="peopleColumn"
    ></wty-permission>
  </div>
</template>
<script>
import wtyPermission from "@/components/wty-permission.vue";
import {
  getMerchantPermissList,
  permissionListAccount
} from "@/api/merchant.js";
export default {
  name: "peopleinfo",
  components: { wtyPermission },
  data() {
    return {
      tableList: [],
      perssionData: {},
      wtypermiss_show: true,
      peopleColumn: [
        {
          prop: "account_name",
          align: "center",
          label: "名字",
          width: "200",
          fixed: "left"
        },
        {
          prop: "account_id",
          align: "center",
          label: "id",
          width: "200",
          fixed: "left"
        }
      ]
    };
  },
  async mounted() {
    this.wtypermiss_show = false;
    const res = await getMerchantPermissList();
    this.perssionData = res;
    this.tableList = await permissionListAccount();
    this.wtypermiss_show = true;
  }
};
</script>
<style scoped>
.father {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 10px 10px 0 10px;
}
</style>
